class MembershipFeeAnalytics {
    constructor() {
        const activate = document.querySelector('.membership-fee');
        if (!activate || typeof ga === 'undefined') return;

        const form = document.querySelector('.membership-fee__form');
        form.addEventListener('submit', this.handleSubmit)
    }

    handleSubmit(e) {
        const membershipSelector = e.target.querySelector('select[name="MemberOrganisation"]');
        const value = membershipSelector.value;

        if (value === "") return;

        const selectedOption = document.querySelector(`option[value="${value}"]`);
        const selectedBranch = selectedOption.innerText;

        if (selectedBranch === "") return;

        dataLayer.push({
            'event': 'membershipCounter',
            'membershipCounterBranch': selectedBranch
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new MembershipFeeAnalytics();
});